import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getHostSummary = async (queryParams) => {
  const { data } = await SigliveServiceV2({
    method: 'GET',
    url: `productivity-host/summary?${queryParams}`,
  });

  return data?.data;
};

export default getHostSummary;
